<script setup lang="ts">
import { onMounted } from "vue";
import { useAppStore } from "@/ts/stores/app";
import { useViewportUtilities } from "@/ts/utils/viewport-utilities";
import { useAnchorEvents } from "@/ts/utils/anchor-events";
import Player from "@vimeo/player";

useViewportUtilities();
useAnchorEvents();

const appStore = useAppStore();

onMounted(() => {
    const iframe = document.querySelector('iframe[src*="vimeo"]') as HTMLIFrameElement;
    if (iframe) {
        const player = new Player(iframe);

        player.on("play", () => {
            iframe.classList.remove("opacity-0");
        });
    }
    appStore.indexPages();
});
</script>
